import { render } from "./VideoTutorial.vue?vue&type=template&id=0c05d7d2&scoped=true"
import script from "./VideoTutorial.vue?vue&type=script&lang=js"
export * from "./VideoTutorial.vue?vue&type=script&lang=js"

import "./VideoTutorial.vue?vue&type=style&index=0&id=0c05d7d2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c05d7d2"]])

export default __exports__